import { Route, Routes } from 'react-router-dom';
import { buildAuthRoutes } from '../auth/AuthRoutes';

import Portal from '../portal/Portal';
import AppSessionProvider from './AppSessionProvider';
import AuthorizedUserGuard from '../auth/AuthorizedUserGuard';
import NPointFinderPage from '../pages-admin/agents/nPointFinder';
import { EnvironmentStoreContainer } from '../../stores/EnvironmentStore';
import { useEnvironmentService } from '../../services/EnvironmentService';
import GotoPulsePage from '../ng1-comm/GotoPulsePage';

function StandaloneNPointFinderRoute() {
    return (
        <AuthorizedUserGuard>
            <EnvironmentStoreContainer environmentService={useEnvironmentService()}>
                <NPointFinderPage />
            </EnvironmentStoreContainer>
        </AuthorizedUserGuard>
    );
}

export default function App() {
    return (
        <Routes className="flex-container">
            {buildAuthRoutes()}

            {/* Public nG1 drill-down entry point — must not require authentication */}
            <Route path="/gotoPulse" element={<GotoPulsePage />} />

            {/* The finder can be opened from both global admin and PLM-scoped admin pages. */}
            <Route
                path="/admin/nPoints/finder"
                element={
                    <AppSessionProvider>
                        <StandaloneNPointFinderRoute />
                    </AppSessionProvider>
                }
            />
            <Route
                path="/plm/:plmId/admin/nPoints/finder"
                element={
                    <AppSessionProvider>
                        <StandaloneNPointFinderRoute />
                    </AppSessionProvider>
                }
            />

            <Route
                path="/*"
                element={
                    <AppSessionProvider>
                        <Portal />
                    </AppSessionProvider>
                }
            />
        </Routes>
    );
}
